import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { setNotification } from "features/Notification/notificationSlice";

const Toast = () => {
  const dispatch = useDispatch();
  const { alerts } = useSelector((state) => state.notifications);
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (alerts.length > 0) {
      setAlert(alerts[alerts.length - 1]);
      setShow(true);
      setTimeout(() => {
        dispatch(
          setNotification({
            message: "",
            type: "",
          })
        );
        setShow(false);
      }, 3000);
    }
  }, [alerts]);

  return show ? (
    <div
      style={{
        zIndex: 99999999999999,
      }}
      className="toast-container position-absolute p-3 top-0 start-50 translate-middle-x"
    >
      <div className="toast show">
        {/* "warning" is its own colour, not a green fall-through.
            Everything that was not "error" used to render green, so a caller
            asking for a warning got a message that looked like clean success
            — which is how a half-finished attendance sync could report
            "done" in the same colour as a finished one. */}
        <div
          className={`toast-body text-white ${
            alert.type === "error"
              ? "bg-danger"
              : alert.type === "warning"
                ? "bg-warning"
                : "bg-success"
          }`}
        >
          {alert.message || ""}
        </div>
      </div>
    </div>
  ) : null;
};

export default Toast;
